<template>
	<BasicLayout>
		<el-card class="entities-card">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="11" :lg="13" :xl="14">
					<el-button 
						size="small" 
						type="primary" 
						icon="fas fa-fw fa-edit" 
						:disabled="!entity.id" 
						title="Modifier l'entité sélectionnée" 
						v-on:click="openEntity()">
						<span class="hidden-xs-only"> Modifier</span>
					</el-button>
					<el-button 
						size="small" 
						type="primary" 
						icon="fas fa-fw fa-times" 
						:disabled="disableValidateButtons" 
						v-if="entity.valid" 
						title="Désactiver l'entité sélectionnée"
						v-on:click="toggleValid()">
						<span class="hidden-xs-only"> Désactiver</span>
					</el-button>
					<el-button 
						size="small" 
						type="primary" 
						icon="fas fa-fw fa-check" 
						:disabled="disableValidateButtons" 
						v-if="!entity.valid" 
						title="Activer l'entité sélectionnée"
						v-on:click="toggleValid()">
						<span class="hidden-xs-only"> Activer</span>
					</el-button>
				</el-col>
				<el-col :xs="24" :sm="12" :md="13" :lg="11" :xl="10">
					<el-input size="small"
						class="search-input"
						placeholder="Rechercher"
						prefix-icon="fas fa-search"
						v-model="searchQuery"
						v-on:input="setSearchQueries"
						v-on:clear="setSearchQueries"
						clearable>
					</el-input>
				</el-col>
			</el-row>

			<el-table
				ref="entitiesTable"
				v-loading="loading"
				:data="filteredEntities" 
				:default-sort="{prop: 'name', order: 'ascending'}"
				@row-click="onSelectRow"
				style="width: 100%"
				height="calc(100vh - 250px)"
				border
				stripe
				highlight-current-row
				class="entities-table">

				<!-- TYPE -->
				<el-table-column label="Type" prop="typeLabel" width="75" sortable></el-table-column>

				<!-- NOM -->
				<el-table-column label="Nom" prop="name" sortable></el-table-column>

				<!-- NOM COURT -->
				<el-table-column label="Nom court" prop="shortName" sortable></el-table-column>
				
				<!-- EMAIL -->
				<el-table-column label="E-mail" prop="email" sortable></el-table-column>
				
				<!-- ADRESSE -->
				<el-table-column label="Adresse" prop="address" sortable></el-table-column>
				
				<!-- DEPARTEMENT -->
				<el-table-column label="Dept" prop="departmentNumber" width="75" align="center" sortable></el-table-column>

				<!-- VALIDE -->
				<el-table-column
					label="Actif"
					width="84"
					align="center"
					:filters="[{ text: 'Oui', value: true }, { text: 'Non', value: false }]"
					:filter-method="filterValid"
					filter-placement="bottom-end">
					<template slot-scope="scope">
						<i v-if="scope.row.valid" class="fas fa-lg fa-check vert-color"></i>
						<i v-if="!scope.row.valid" class="fas fa-lg fa-times rouge-color"></i>
					</template>
				</el-table-column>
				
			</el-table>
		</el-card>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout'
import EntityService from '@/services/entity.service'
import StringUtils from '@/utils/string.utils'
import EntityTypes from '@/constants/entity.types.const'

export default {
	name: 'entities',
	components: {
		BasicLayout
	},
	data: function () {
		return {
			entities: [],
			loading: true,
			searchQuery: '',
			searchQueries: [],
			entity: {}
		}
	},
	computed: {
		filteredEntities: function () {

			if (!this.searchQueries || this.searchQueries.length === 0) {
				return this.entities
			}

			return this.entities.filter(entity => {
				return StringUtils.matchAll(entity.searchText, this.searchQueries)
			})
		},
		disableValidateButtons: function () {
			return !this.entity.id || this.entity.typeCode !== EntityTypes.SAU
		}
	},
	methods: {
		getData() {

			this.loading = true

			// Appel de l'api
			EntityService.getEntities().then((entities) => {

				// Pour chaque ligne,
				// Construit une string utilisée pour la recherche textuelle
				entities.forEach(entity => {
					entity.searchText = Object.values(entity).join(" ")
				});

				this.entities = entities
				this.loading = false

				this.$nextTick(function () {
					this.$refs.entitiesTable.doLayout()
				})
			})
		},
		filterValid(value, row) {
			return row.valid === value;
		},
		setSearchQueries() {
			if (this.timeout) clearTimeout(this.timeout); 
			this.timeout = setTimeout(() => {

				if (this.searchQuery) {
					this.searchQueries = this.searchQuery.split(' ')
				} else {
					this.searchQueries = []
				}

			}, 350);
		},
		onSelectRow(row) {

			if (!this.entity.id || row.id !== this.entity.id) {
				this.entity = row
			} else {
				this.entity = {}
				this.$refs.entitiesTable.setCurrentRow();
			}
		},
		openEntity() {
			this.$router.push('/entities/' + this.entity.id)
		},
		toggleValid() {

			// Affiche le loader
			this.loading = true

			// Mise a jour de l'entité
			const entity = { id: this.entity.id, valid: !this.entity.valid }
			EntityService.updateEntity(entity).then((entity) => {

				// Met a jour l'objet affiché
				this.entity.valid = !this.entity.valid
				this.entities.forEach(entity => {
					if (entity.id === this.entity.id) {
						entity.valid = this.entity.valid
					}
				});

				// Masque le loader
				this.loading = false
			})
		}
	},
	mounted: function() {

		// Récupère la liste des entités
		this.getData()
		
	}
}
</script>

<style scoped>

.entities-card {
	height: calc(100vh - 165px);
}

h1 {
	margin-bottom: 0;
}

.entities-table {
	margin-top: 15px;
}

@media only screen and (max-width:991px) {

	/* Masque la colonne nom court */
	.entities-table colgroup col:nth-child(3),
	.entities-table thead th:nth-child(3),
	.entities-table tbody td:nth-child(3) {
		display: none;
	}
}

@media only screen and (max-width:767px) {

	.search-input {
		 margin-top: 15px;
	}

	.entities-table {
		height: calc(100vh - 245px) !important;
	}

	.entities-card {
	height: calc(100vh - 120px);
}

	/* Masque la colonne email */
	.entities-table colgroup col:nth-child(4),
	.entities-table thead th:nth-child(4),
	.entities-table tbody td:nth-child(4) {
		display: none;
	}

	/* Masque la colonne adresse */
	.entities-table colgroup col:nth-child(5),
	.entities-table thead th:nth-child(5),
	.entities-table tbody td:nth-child(5) {
		display: none;
	}
	
	/* Masque la colonne email */
	.entities-table colgroup col:nth-child(6),
	.entities-table thead th:nth-child(6),
	.entities-table tbody td:nth-child(6) {
		display: none;
	}
}

</style>